module.exports = __webpack_public_path__ + "static/media/Receipe1.61250731.svg";